import { jsx as n } from "react/jsx-runtime";
import { useState as i, useEffect as d } from "react";
import { Skeleton as m, Typography as c } from "@mui/material";
function g({ html: r, variant: a = "body1" }) {
  const [f, s] = i(""), [l, o] = i(!0);
  return d(() => {
    let t = !0;
    return import("dompurify").then((e) => {
      if (!t) return;
      const u = e.default;
      s(u.sanitize(r)), o(!1);
    }).catch((e) => {
      console.error("Failed to load DOMPurify:", e), t && o(!1);
    }), () => {
      t = !1;
    };
  }, [r]), l ? /* @__PURE__ */ n(m, { variant: "text" }) : /* @__PURE__ */ n(
    c,
    {
      variant: a,
      dangerouslySetInnerHTML: { __html: f }
    }
  );
}
export {
  g as SanitizedHtml
};
//# sourceMappingURL=SanitizedHtml.js.map
